import React from 'react';
import { Link } from 'react-router-dom';
import { AFFORDABILITY_CALCULATOR_PATH } from '../config/calculatorPaths';
import {
  isMortgagePointsCalculatorEnabled,
  MORTGAGE_POINTS_CALCULATOR_PATH,
} from '../config/featureFlags';
import {
  ONTARIO_MORTGAGE_CALCULATOR_PATH,
  BC_MORTGAGE_CALCULATOR_PATH,
  ALBERTA_MORTGAGE_CALCULATOR_PATH,
} from '../config/provinceCalculatorPages';
import { openCookiePreferences } from '../utils/openCookiePreferences';

const SITE_ESTABLISHED_YEAR = 2025;

export const Footer: React.FC = () => {
  const linkClass = 'text-navy-200 hover:text-gold-300 text-sm transition-colors';
  const headingClass = 'text-white text-sm font-semibold tracking-wide uppercase mb-3';
  const currentYear = new Date().getFullYear();
  const copyrightYear =
    currentYear > SITE_ESTABLISHED_YEAR
      ? `${SITE_ESTABLISHED_YEAR}-${currentYear}`
      : `${SITE_ESTABLISHED_YEAR}`;

  return (
    <footer className="bg-navy-900 border-t border-navy-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 py-8">
          <div>
            <p className="font-serif text-white text-base">
              Mortgage<span className="text-gold-400">Compare</span>
            </p>
            <p className="text-xs text-navy-400 mt-1">
              © {copyrightYear} MortgageCompareCalculator.com.
              <br />All rights reserved.
            </p>
          </div>

          <nav aria-label="Tools">
            <p className={headingClass}>Tools</p>
            <ul className="space-y-2">
              <li><Link to="/" className={linkClass}>Mortgage Calculator</Link></li>
              <li><Link to={AFFORDABILITY_CALCULATOR_PATH} className={linkClass}>Home Affordability Calculator</Link></li>
              {isMortgagePointsCalculatorEnabled && (
                <li>
                  <Link to={MORTGAGE_POINTS_CALCULATOR_PATH} className={linkClass}>
                    Mortgage Points Calculator
                  </Link>
                </li>
              )}
              <li><Link to="/faq" className={linkClass}>FAQ</Link></li>
            </ul>
          </nav>

          <nav aria-label="Province calculators">
            <p className={headingClass}>Province calculators</p>
            <ul className="space-y-2">
              <li>
                <Link
                  to={ONTARIO_MORTGAGE_CALCULATOR_PATH}
                  className={linkClass}
                >
                  Ontario Mortgage Calculator
                </Link>
              </li>
              <li>
                <Link
                  to={BC_MORTGAGE_CALCULATOR_PATH}
                  className={linkClass}
                >
                  BC Mortgage Calculator
                </Link>
              </li>
              <li>
                <Link
                  to={ALBERTA_MORTGAGE_CALCULATOR_PATH}
                  className={linkClass}
                >
                  Alberta Mortgage Calculator
                </Link>
              </li>
            </ul>
          </nav>

          <nav aria-label="Resources">
            <p className={headingClass}>Resources</p>
            <ul className="space-y-2">
              <li><Link to="/learn" className={linkClass}>Learn</Link></li>
              <li><Link to="/learn/compare" className={linkClass}>Comparisons</Link></li>
              <li><Link to="/learn/scenarios" className={linkClass}>Scenarios</Link></li>
              <li><Link to="/learn/guides" className={linkClass}>Guides</Link></li>
            </ul>
          </nav>

          <nav aria-label="Company">
            <p className={headingClass}>Company</p>
            <ul className="space-y-2">
              <li><Link to="/about" className={linkClass}>About</Link></li>
              <li><Link to="/contact" className={linkClass}>Contact</Link></li>
              <li><Link to="/feedback" className={linkClass}>Share Feedback</Link></li>
              <li><Link to="/privacy-policy" className={linkClass}>Privacy Policy</Link></li>
              <li>
                <button
                  type="button"
                  onClick={() => openCookiePreferences()}
                  className={`${linkClass} text-left`}
                >
                  Manage cookie preferences
                </button>
              </li>
            </ul>
          </nav>
        </div>

        <div className="py-4 border-t border-navy-800">
          <p className="text-xs text-navy-500 text-center">
            Disclaimer: This calculator is for informational purposes only and should not be considered financial advice.
            Always consult with a qualified financial professional before making financial decisions.
          </p>
        </div>
      </div>
    </footer>
  );
};
